module.exports = require("@sentry/browser");;